module.exports = __webpack_public_path__ + "img/custom-2.f46a577.png";